import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200/70">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-xl font-bold font-heading text-primary-600 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-plant-line" />
              </span>
              黄瓜传媒
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              专注于品牌内容创作、数字营销与媒体传播，为企业提供一站式传播解决方案。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="https://weibo.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-line" />
              </a>
              <a
                href="https://weixin.qq.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors"
                aria-label="微信"
              >
                <i className="ri-wechat-line" />
              </a>
              <a
                href="https://www.xiaohongshu.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors"
                aria-label="小红书"
              >
                <i className="ri-book-read-line" />
              </a>
              <a
                href="https://www.douyin.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors"
                aria-label="抖音"
              >
                <i className="ri-music-line" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              服务项目
            </h3>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              快速导航
            </h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/brand-planning" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  品牌策划
                </Link>
              </li>
              <li>
                <Link to="/category/video-production" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  视频制作
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              联系我们
            </h3>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-primary-500" />
                </span>
                北京市朝阳区建国路88号SOHO现代城A座2208室
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-primary-500" />
                </span>
                400-888-6666
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-primary-500" />
                </span>
                hello@cucumbermedia.cn
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-primary-500" />
                </span>
                周一至周五 09:00-18:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-secondary-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2024 黄瓜传媒 Cucumber Media. 保留所有权利。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <Link to="/about" className="hover:text-primary-600 transition-colors">
              关于我们
            </Link>
            <span className="text-foreground-300">|</span>
            <a href="#" className="hover:text-primary-600 transition-colors">
              隐私政策
            </a>
            <span className="text-foreground-300">|</span>
            <a href="#" className="hover:text-primary-600 transition-colors">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}